export const APP_NAME = 'VueStarter'
export const API_URL_BASE = 'https://api.example.com/v1'
export const AUTH_TOKEN_NAME = `${APP_NAME}_TOKEN`
export const USER_TOKEN_NAME = `${AUTH_TOKEN_NAME}_USER`
